import React from "react";
import { interpolate, useCurrentFrame } from "remotion";

export const SolarFlareBackground: React.FC = () => {
  const frame = useCurrentFrame();

  // Pulse effect for the core solar glow
  const coreGlowScale = interpolate(
    Math.sin(frame / 20),
    [-1, 1],
    [0.9, 1.1]
  );

  const coreGlowOpacity = interpolate(
    Math.sin(frame / 30),
    [-1, 1],
    [0.4, 0.7]
  );

  // Cinder particle data: [x%, y%, size, speed, phase]
  const cinders = [
    { x: 10, y: 90, size: 4, speed: 3, phase: 0 },
    { x: 25, y: 85, size: 6, speed: 2.5, phase: 10 },
    { x: 40, y: 95, size: 3, speed: 3.5, phase: 20 },
    { x: 55, y: 80, size: 5, speed: 2.8, phase: 5 },
    { x: 70, y: 92, size: 4, speed: 3.2, phase: 15 },
    { x: 85, y: 88, size: 6, speed: 2.4, phase: 25 },
    { x: 15, y: 70, size: 3, speed: 3.1, phase: 30 },
    { x: 35, y: 75, size: 5, speed: 2.7, phase: 40 },
    { x: 65, y: 65, size: 4, speed: 3.3, phase: 50 },
    { x: 90, y: 72, size: 3, speed: 2.9, phase: 60 },
    { x: 20, y: 50, size: 4, speed: 3.4, phase: 70 },
    { x: 50, y: 40, size: 6, speed: 2.6, phase: 80 },
    { x: 80, y: 55, size: 3, speed: 3.0, phase: 90 },
  ];

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#050200",
        overflow: "hidden",
        zIndex: 0,
      }}
    >
      {/* Primary Solar Flare Core */}
      <div
        style={{
          position: "absolute",
          top: "30%",
          left: "50%",
          width: "800px",
          height: "800px",
          background: "radial-gradient(circle, #1a0f00 0%, transparent 70%)",
          transform: `translate(-50%, -50%) scale(${coreGlowScale})`,
          opacity: coreGlowOpacity,
          zIndex: 1,
        }}
      />

      {/* Secondary Pulse layer */}
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          background: "radial-gradient(circle at 50% 100%, rgba(255, 69, 0, 0.05) 0%, transparent 80%)",
          zIndex: 2,
        }}
      />

      {/* Floating Cinders */}
      {cinders.map((cinder, i) => {
        const driftY = interpolate(
          (frame * cinder.speed + cinder.phase * 10) % 1920,
          [0, 1920],
          [0, -1920]
        );
        const horizontalSway = Math.sin((frame + cinder.phase) / 15) * 20;
        const opacity = interpolate(
          (frame * cinder.speed + cinder.phase * 10) % 1920,
          [0, 200, 1720, 1920],
          [0, 1, 1, 0]
        );

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              left: `${cinder.x}%`,
              bottom: "0%",
              width: cinder.size,
              height: cinder.size,
              background: "#FFD700",
              borderRadius: "50%",
              boxShadow: "0 0 10px #FF4500",
              transform: `translate(${horizontalSway}px, ${driftY}px)`,
              opacity,
              zIndex: 3,
            }}
          />
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
